import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,_vm._b({attrs:{"autocomplete":"off","data-test":_vm.dataTestAttr,"label":_vm.label,"outlined":!_vm.inPlace,"required":_vm.required,"rules":_vm.mergedRules,"validate-on-blur":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }